module.exports = __webpack_public_path__ + "img/color-x-2@2x.795dfc4.webp";